module.exports = __webpack_public_path__ + "img/selected0-min.5fa84012.png";